import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
} from "@material-ui/core";
import { doctorServices } from "../services";
import { AuthContext } from "../context";
import {
  SimpleToolbar,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { useDrawer } from "../hooks";
import handleDownloadExcel from "../helpers/download-excel";
export default function DoctorAssignmentsTop(props) {
  const classes = useStyles();
  const [doctors, setDoctors] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  // const [toast, setToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState('');
  const [reload, setReload] = useState(false);
  const { isOpen, setIsOpen } = useDrawer();
  const tableHeader = useRef([
    "Asignaciones",
    "RUT",
    "Nombre",
    "Apellido",
    "Sexo",
    "Fecha de nacimiento",
    "Teléfono",
    "Correo",
    "Especialidad 1",
    "Especialidad 2",
    "Especialidad 3",
  ]);
  const tableBody = useRef([]);

  useEffect(() => {
    const tableData = doctors.map((user) => {
      return {
        Asignaciones: user.count || "",
        RUT: user.doctor.rut || "",
        Nombre: user.doctor.name || "",
        Apellido: user.doctor.lastName || "",
        Sexo: user.doctor.gender || "",
        "Fecha de nacimiento": user.doctor.birthdate || "",
        Teléfono: user.doctor.gender || "",
        Correo: user.doctor.email || "",
        "Especialidad 1": user.doctor.specialties[0]
          ? user.doctor.specialties[0]?.name
          : "N/A",
        "Especialidad 2": user.doctor.specialties[1]
          ? user.doctor.specialties[1]?.name
          : "N/A",
        "Especialidad 3": user.doctor.specialties[2]
          ? user.doctor.specialties[2]?.name
          : "N/A",
      };
    });
    tableBody.current = tableData;
  }, [doctors]);

  useEffect(() => {
    setReload(false);
    getDoctorAssignmentsTop("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload]);

  const getDoctorAssignmentsTop = async (text) => {
    try {
      setLoading(true);
      const { status, response } = await doctorServices.getDoctorAssignmentsTop(
        { text, page, limit, token: authState.token }
      );
      setLoading(false);
      if (status === 200) {
        setDoctors(response.doctors);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Medicos con mas asignaciones",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12}>
          <div className={classes.root}>
            <Container maxWidth={false}>
              <SimpleToolbar
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                onFilter={(text) => getDoctorAssignmentsTop(text)}
                options={optionsToolbar}
              />
              {/* <Toast message={toastMessage} open={toast} close={() => { setToast(false) }} /> */}
              <BaseTable tableId="tableDoctors">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Asignaciones</StyledTableCell>
                    <StyledTableCell>Rut</StyledTableCell>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Apellido</StyledTableCell>
                    <StyledTableCell>Sexo</StyledTableCell>
                    <StyledTableCell>Fecha de nacimiento</StyledTableCell>
                    <StyledTableCell>Teléfono</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Especialidad 1</StyledTableCell>
                    <StyledTableCell>Especialidad 2</StyledTableCell>
                    <StyledTableCell>Especialidad 3</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {doctors.map((doctor, index) => (
                    <StyledTableRow hover key={doctor._id}>
                      <StyledTableCell
                         
                      >
                        {doctor.count}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.rut.charAt(
                          doctor.doctor.rut.length - 2
                        ) === "-"
                          ? doctor.doctor.rut
                          : `${doctor.doctor.rut.slice(
                              0,
                              doctor.doctor.rut.length - 1
                            )}-${doctor.doctor.rut.slice(
                              doctor.doctor.rut.length - 1
                            )}`}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.name}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.lastName}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.gender}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.birthdate !== "Invalid date"
                          ? doctor.doctor.birthdate
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.phone ? doctor.doctor.phone : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.email ? doctor.doctor.email : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.specialties[0].name}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.specialties[1]
                          ? doctor.doctor.specialties[1].name
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {doctor.doctor.specialties[2]
                          ? doctor.doctor.specialties[2].name
                          : "N/A"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onRowsPerPageChange={(e) => {
                  setLimit(e.target.value);
                }}
                onPageChange={(e, page) => {
                  setPage(page + 1);
                }}
                className={classes.pagination}
                color={"#2096C0"}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
